export default __webpack_public_path__ + "static/media/cherryblossomscreations.6c4d64c8.svg";